import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import moment from "moment";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import ToggleButton from "react-bootstrap/ToggleButton";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ListGroup from "react-bootstrap/ListGroup";
import { postDelivery } from "../actions/deliveryAction";
import checkMark from "./kind.png";

class ScheduleDelivery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMatching: true,
      chooseDeliveryTime: false,
      // deliveryDay: "tod",
      filteredDate: moment(Date.Now).format("YYYY-MM-DD"),
      delivery_instructions: "",
      phone: "",
      date: "",
      fulfillment_id: 0,
      session_id: 0,
      shopify_order_id: 0,
      shipto_first_name: "",
      shipto_last_name: "",
      customer_email: "",
      shipto_address1: "",
      shipto_address2: "",
      shipto_city: "",
      shipto_province: "",
      shipto_zip: "",
      total_price: 0,
      shipfrom_name: "",
      bdate_id: 0,
      booking_id: 0,
      delivery_window: "",
      // merchant: "",
      merchant_id: 0,
      custom_order: false,
      pick_up: false,
      delivery: true,
      contact_customer: true,
      contact_via_sms_only: false,
      contact_via_email_only: false,
      retailers_notes: false,
      shipfrom_address1: "",
      shipfrom_zip: "",
      shipfrom_city: "",
      shipfrom_province: "",
      number_of_bags: 0,
      webbooking: false,
      price: 0,
      return: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleDateClick = this.handleDateClick.bind(this);
  }
  componentDidMount() {
    this.props;
    const { fulfillment } = this.props.fulfillment;
    const { bdates } = this.props.fulfillment;

    this.setState({
      fulfillment_id: fulfillment.id,
      shopify_order_id: fulfillment.shopify_id,
      shipto_first_name: fulfillment.shipto_first_name,
      shipto_last_name: fulfillment.shipto_last_name,
      customer_email: fulfillment.shipto_email,
      shipto_address1: fulfillment.shipto_address1,
      shipto_address2: fulfillment.shipto_address2,
      shipto_city: fulfillment.shipto_city,
      shipto_province: fulfillment.shipto_province,
      shipto_zip: fulfillment.shipto_zip,
      total_price: fulfillment.total_price,
      shipfrom_name: fulfillment.merchant,
      merchant: fulfillment.merchant,
      merchant_id: fulfillment.merchant_id,
      filteredDate: bdates[0].date,
    });
  }
  handleDateClick(newDate) {
    this.setState((state) => ({
      filteredDate: newDate,
    }));
  }
  handleTimeClick(newSlot) {
    const clickedSlot = this.props.fulfillment.timeslots.find(
      (slot) => slot.id === newSlot
    );
    this.setState((state) => ({
      booking_id: newSlot,
      delivery_window: clickedSlot.delivery_window,
      bdate_id: clickedSlot.bdate_id,
      date: this.state.filteredDate,
      chooseDeliveryTime: true,
    }));
  }
  handleClick(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    formData.append(
      "delivery[delivery_instructions]",
      this.state.delivery_instructions
    );
    formData.append("delivery[phone]", this.state.phone);
    formData.append("delivery[fulfillment_id]", this.state.fulfillment_id);
    formData.append("delivery[shopify_order_id]", this.state.shopify_order_id);
    formData.append(
      "delivery[shipto_first_name]",
      this.state.shipto_first_name
    );
    formData.append("delivery[shipto_last_name]", this.state.shipto_last_name);
    formData.append("delivery[customer_email]", this.state.customer_email);
    formData.append("delivery[shipto_address1]", this.state.shipto_address1);
    formData.append("delivery[shipto_address2]", this.state.shipto_address2);
    formData.append("delivery[shipto_city]", this.state.shipto_city);
    formData.append("delivery[shipto_province]", this.state.shipto_province);
    formData.append("delivery[shipto_zip]", this.state.shipto_zip);
    formData.append("delivery[total_price]", this.state.total_price);
    formData.append("delivery[shipfrom_name]", this.state.shipfrom_name);
    // formData.append("delivery[merchant]", this.state.merchant);
    formData.append("delivery[merchant_id]", this.state.merchant_id);
    formData.append("delivery[booking_id]", this.state.booking_id);
    formData.append("delivery[date]", this.state.date);
    formData.append("delivery[bdate_id]", this.state.bdate_id);
    formData.append("delivery[delivery_window]", this.state.delivery_window);
    formData.append("delivery[custom_order]", this.state.custom_order);
    formData.append("delivery[pick_up]", this.state.pick_up);
    formData.append("delivery[delivery]", this.state.delivery);
    formData.append("delivery[contact_customer]", this.state.contact_customer);
    formData.append("delivery[retailers_notes]", this.state.retailers_notes);
    formData.append("delivery[number_of_bags]", this.state.number_of_bags);
    formData.append("delivery[webbooking]", this.state.webbooking);
    formData.append("delivery[price]", this.state.price);
    formData.append("delivery[return]", this.state.return);

    this.props.postDelivery(formData, config);
  }
  redirect = () => {
    this.props.history.push({ pathname: "/trackers" });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  render() {
    const { timeslots, fulfillment, bdates } = this.props.fulfillment;
    moment.locale("en-gb");
    const filteredTimeslots = timeslots.filter((slot) => {
      if (this.state.filteredDate == moment(Date.Now).format("YYYY-MM-DD")) {
        return slot.date == this.state.filteredDate;
      } else return slot.date == this.state.filteredDate;
    });
    return (
      <Row className="container-fluid">
        <Col sm="4">
          <Nav className="flex-column">
            <Row>
              <Form.Group as={Col} controlId="formGridMerchant">
                <Form.Label>Delivery from</Form.Label>
                <Form.Control
                  readOnly
                  name="merchantName"
                  value={fulfillment.merchant}
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="formGridFullName">
                <Form.Label>Deliver to</Form.Label>
                <Form.Control
                  name="full_name"
                  readOnly
                  value={
                    fulfillment.shipto_full_name
                      ? fulfillment.shipto_full_name
                      : `${fulfillment.shipto_first_name} ${fulfillment.shipto_last_name}`
                  }
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="formGridFullAddress">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  name="address"
                  value={`${fulfillment.shipto_address1}, ${fulfillment.shipto_city}, ${fulfillment.shipto_zip}`}
                  readOnly
                />
              </Form.Group>
            </Row>
          </Nav>
        </Col>
        <Col sm="8">
          {this.state.chooseDeliveryTime ? (
            <div>
              <ButtonGroup>
                <Button
                  type="checkbox"
                  disabled
                  variant="outline-danger"
                  checked
                  onClick={this.handleClick}
                >
                  <span className="text-dark">Delivery Time Selected:</span> `
                  {moment(this.state.date).format("dddd, MMMM Do")}{" "}
                  {this.state.delivery_window}`
                </Button>
                <Button
                  type="checkbox"
                  variant="outline-info"
                  onClick={() => this.setState({ chooseDeliveryTime: false })}
                >
                  Change Delivery Time
                </Button>
              </ButtonGroup>
              <Form onSubmit={this.handleSubmit}>
                <h5 className="lead mt-2 text-center">Additional Info</h5>
                <Form.Row>
                  <Form.Group as={Col} controlId="formGridInstructions">
                    <Form.Label>Delivery Instructions</Form.Label>
                    <Form.Control
                      name="delivery_instructions"
                      onChange={this.handleInputChange}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} controlId="formGridPhone">
                    <Form.Label>Contact Phone</Form.Label>
                    <Form.Control
                      name="phone"
                      onChange={this.handleInputChange}
                    />
                  </Form.Group>
                </Form.Row>
                <Button variant="primary" type="submit">
                  Submit
                </Button>
              </Form>
            </div>
          ) : (
            <div className="d-flex flex-column">
              <h6 className="text-center">
                Select a delivery time and let us know what we can do to make
                your delivery perfect.
              </h6>
              <div>
                <ToggleButtonGroup
                  name="deliveryDay"
                  type="radio"
                  className="mt-1 mb-1"
                  defaultValue="tod"
                >
                  {bdates.map((bdate) => (
                    <ToggleButton
                      key={bdate.id}
                      value={
                        this.state.filteredDate ==
                        moment(bdate.date).format("YYYY-MM-DD")
                          ? "tod"
                          : "tom"
                      }
                      variant="outline-info"
                      type="radio"
                      onClick={() =>
                        this.handleDateClick(
                          moment(bdate.date).format("YYYY-MM-DD")
                        )
                      }
                    >
                      {moment(bdate.date).format("dddd, MMMM Do")}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
                {filteredTimeslots.map((slot, i) => {
                  const renderElement = () => {
                    if (slot.status == "available") return "primary";
                    else if (slot.status == "eco") return "success";
                    return null;
                  };
                  const renderTooltip = (props) => (
                    <Tooltip id="button-tooltip" {...props}>
                      {slot.status}
                    </Tooltip>
                  );

                  return (
                    <ListGroup
                      key={filteredTimeslots[i].id}
                      className="text-center"
                    >
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <ListGroup.Item
                          variant={renderElement()}
                          action={true}
                          onClick={() =>
                            this.handleTimeClick(filteredTimeslots[i].id)
                          }
                        >
                          {filteredTimeslots[i].delivery_window}
                        </ListGroup.Item>
                      </OverlayTrigger>
                    </ListGroup>
                  );
                })}
              </div>
            </div>
          )}
        </Col>
      </Row>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  postDelivery: (delivery) => dispatch(postDelivery(delivery)),
});
export default connect(null, mapDispatchToProps)(ScheduleDelivery);
